import axios from '@/plugins/axios';
export function supplierList(params) {
  return axios.post('/bidInviteSupplier/supplierList', params);
}
export function listSupplier(params) {
  return axios.post('/bidInviteSupplier/listSupplier', params);
}
export function saveIS(projectId, supplierIds) {
  return axios.post('/bidInviteSupplier/saveIS', { projectId: projectId, supplierIds: supplierIds });
}
export function deleteIS(projectId, inviteIds) {
  return axios.post('/bidInviteSupplier/deleteIS', { projectId: projectId, inviteIds: inviteIds });
}
export function previewSupplier(params) {
  return axios.post('/bidInviteSupplier/previewSupplier', params);
}
